import { atom } from 'jotai'

import type { Plan } from '~shared/types'

import { cuesDerived } from '@/features/rundown/cue/cue.derived'

//
// Payment plan
//
export const planAtom = atom<Plan | null>(null)

export const getIsCuesLimitExceededAtom = atom(
  null,
  (get, _set, cueCountToAdd: number) => {
    const plan = get(planAtom)

    if (!plan) return false

    // Read straight from the valtio store
    const cuesCount = cuesDerived.cueCount

    return (
      plan.limits.cues !== -1 && plan.limits.cues < cuesCount + cueCountToAdd
    )
  },
)
